export default __webpack_public_path__ + "static/media/IMG_9946.b9b01117.jpeg";